<template>
  <div class="home page-container" >
    <!--banner-->
    <div class="banner">
      <swiper :options="bannerSwiper">
        <!-- slides -->
        <swiper-slide v-for="(item,index) in filterBillboard(this.$store.state.billboard.billboardImages, $i18n.locale)" data-index="index" :key="index">
          <div v-if="item.URL"><a :href="item.URL"><img class='swiImg' :src='item.Image' /></a></div>
          <div v-else><img class='swiImg' :src='item.Image' /></div>
        </swiper-slide>
      </swiper>
      <div class="banner-button-prev"></div>
      <div class="banner-button-next"></div>
    </div>
    <!--end banner-->

    <!--category 2 products-->
    <div v-for="(item,index) in customCategories" v-model="local=item.Products=='local'" data-index="index" :key="index">
      <div class="Bestsellers" :class="(index=='3') ? 'paddingFix' : (customCategories[4].ListViewType=='middle-image' && index=='5') ? 'paddingFix':''">
        <div class="page-width">
          <div v-if="item.ListViewType!=='middle-image' && item.Products.length>0" class="padding">
            <!--cat2-->
            <div class="text-center">
              <h2 v-if='$i18n.locale=="en"'>{{item.Name}}</h2>
              <h2 v-if='$i18n.locale=="ch"'>{{item.Description}}</h2>
            </div>
            <swiper :options="productSwiper" ref="mySwiper">
              <!-- slides -->
              <swiper-slide v-for="(p, index) in item.Products" :key="index" v-if="!p.IsStopSale">
                <productCard
                  v-if='$i18n.locale=="en"'
                  v-bind:img="p.Thumbnail"
                  v-bind:link="p.link"
                  v-bind:name="p.Name"
                  v-bind:isPromotion="p.IsPromotion"
                  v-bind:price="p.Price"
                  v-bind:item="p"
                  v-bind:quantity="p.Quantity"
                  v-bind:key="index"
                ></productCard>
                <productCard
                  v-if='$i18n.locale=="ch"'
                  v-bind:img="p.Thumbnail"
                  v-bind:link="p.link"
                  v-bind:name="p.Description"
                  v-bind:isPromotion="p.IsPromotion"
                  v-bind:price="p.Price"
                  v-bind:item="p"
                  v-bind:quantity="p.Quantity"
                  v-bind:key="index"
                ></productCard>
              </swiper-slide>
            </swiper>
            <div v-if="item.Products.length>5" class="swiper-button-prev swp1"></div>
            <div v-if="item.Products.length>5" class="swiper-button-next swp1"></div>
          </div>
          <!-- left -->
          <div v-if="item.ListViewType=='middle-image' && ( index=='1' || index=='3')" class="medium-up--one-half" @click="goToCategory2(item)">
            <img :src="item.Image" alt="">
          </div>
          <!-- right -->
          <div v-if="item.ListViewType=='middle-image' && ( index=='2' || index=='4')" class="medium-up--one-half marginFix" @click="goToCategory2(item)">
            <img :src="item.Image" alt="">
          </div>
        </div>
      </div>
    </div>
    <!-- end category 2 products-->
    <div class="goToCollections">
       <img class='swiImg' src='../../assets/img/bottom_banner.png' alt=""/>
    </div>
    <!-- recipes-->
    <div class="Custom">
      <div class="index-section">
        <div class="page-width text-center">
          <h2>{{ $t('recipesForYou') }}</h2>
          <div class="home-recipe">
            <ul>
              <li v-for="(item,index) in this.$store.state.recipe.fourRecipes" :key='index' @click="goToRecipeDetail(item.recipe_id)">
                <div class="recipe-image">
                  <img v-if="item.image_file" :src="item.image_file" alt="">
                  <img v-else src="../../assets/img/coming.png" alt="">
                </div>
                <div class="recipe-text">
                  <p><strong>{{item.title}}</strong></p>
                  <p class="mobile-hide"><span v-html="item.rich_text_description"></span></p>
                </div>
              </li>
            </ul>
          </div>
          <button @click="goToRecipes"><span>{{ $t('readMore') }}</span></button>
        </div>
      </div>
    </div>
    <!-- end recipes -->
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import axios from 'axios';
import $ from 'jquery';
import { isUserAuthenticated, flyToElement } from '../../store/modules/cart';
import productCard from '../productCard';
import { CUSTOMER_INFORMATION_URL } from '../../api/url';

export default {
  name: "b2cHome",
  components: {
    productCard,
  },
  data() {
    return {
      // swiper api：https://www.swiper.com.cn/api/index.html (https://swiperjs.com/)
      bannerSwiper: {
        autoplay: {
          delay: 15000,
          disableOnInteraction: false,
        },
        simulateTouch: false,
        navigation: {
          nextEl: '.banner-button-next',
          prevEl: '.banner-button-prev',
        },
      },
      productSwiper: {
        slidesPerView: 5,
        navigation: {
          nextEl: '.swiper-button-next.swp1',
          prevEl: '.swiper-button-prev.swp1',
        },
        breakpoints: {
          320: {
            slidesPerView: 2,
          },
          //when width >= 480
          480:{
            slidesPerView: 2,
          },
          767: {
            slidesPerView: 2,
          },
          //when width >= 640
          990: {
            slidesPerView: 3,
          },
          1200:{
            slidesPerView: 4,
          },
          1280: {
            slidesPerView: 5,
          }
        }
      },
      isb2b: true,
    }
  },
  methods:{
    ...mapActions('recipe', ['fetchRecipes, fetch4Recipes, fetchRecipeDetail']),
    ...mapMutations('recipe', ['updateRecipeId']),
    ...mapActions('cart', ['addProductToCart']),
    ...mapActions('products', ['fetchProductDetails']),
    ...mapMutations('products', ['updateActiveProduct']),
    ...mapMutations('checkout', ['setPricesForCheckout', 'saveTotalPrice', 'saveGrandTotal', 'clearPromoCode', 'clearCard']),
    // collections rout not for afg
    goToCollections() {
      this.$router.push('/collections')
    },
    goToCategory2(cat2) {
      this.$router.push(`/category2/${cat2.Name.toLowerCase()}`)
    },
    goToRecipes(){
      this.$router.push('/recipes')
    },
    handleAddToCartSuccess(item) {
      this.$store.dispatch('cart/addCart', item)
      .then(() => {
        this.$store.dispatch('cart/getCart');
      });
    },
    handleAddToCartFail() {
      alert('Not enough product in stock');
    },
    goToRecipeDetail(id) {
      this.updateRecipeId(id);
      this.$router.push(`/recipe/${id}`);
    },
    filterBillboard(billboard, language) {
      // filter language
      let filterBillboard = billboard.filter(image => {
        return image.Language.toLowerCase() === language;
      });
      // filter customerType: all, b2c, b2b
      if (isUserAuthenticated()) {
        this.isB2B();
        if (this.isb2b === true) {
          filterBillboard = filterBillboard.filter(image => {
            return (image.CustomerType === 'b2b' || image.CustomerType === 'all');
          });
        } else {
          filterBillboard = filterBillboard.filter(image => {
            return (image.CustomerType === 'b2c' || image.CustomerType === 'all');
          });
        }
      } else {
        filterBillboard = filterBillboard.filter(image => {
          return (image.CustomerType === 'b2c' || image.CustomerType === 'all');
        });
      }
      return filterBillboard;
    },
    addToCart: function(item, event) {
      if (isUserAuthenticated()) {
        this.addProductToCart({success: this.handleAddToCartSuccess, fail: this.handleAddToCartFail, item})
        .then(() => {
          flyToElement(event.target, $('.cart-link'));
        })
      } else {
        this.$store.dispatch('cart/addProductToLocalCart', item)
        .then(() => {
          this.$store.dispatch('cart/getCart');
          flyToElement(event.target, $('.cart-link'));
        })
      }
    },
    beforeRouteLeave(to, from, next) {
      if (isUserAuthenticated() && to.name === 'purchase') {
        this.$store.dispatch('cart/getCart')
        .then(() => {
          const cartItems = {};
          cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
          cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
          cartItems.ShippingMethod = "Delivery";
          cartItems.Tip = 0;
          cartItems.TipPercentage = 0;
          cartItems.TotalPrice =  this.$store.state.cart.cartProductsList.TotalPrice;
          this.$store.dispatch('cart/saveAndAdjustCart', cartItems)
          .then(() => {
            this.saveGrandTotal(this.necessaryCartItems.GrandTotal);
            this.saveTotalPrice(this.necessaryCartItems.TotalPrice);
          })
        })
      }
      this.clearPromoCode();
      this.clearCard();
      next();
    },
    // return a B2B promise that doesn't pollute the customer data to determine if you need to load b2b products or b2c ones. See how it works in mounted.
    isB2B() {
      const token = localStorage.getItem('token');
      const config = {
        method: 'get',
        url: CUSTOMER_INFORMATION_URL,
        headers: {
          Authorization: `JWT ${token}`,
        }
      };
      let b2b = axios(config).then( (res) => {
        this.isb2b=res.data.IsBusiness;
        return res.data.IsBusiness;
      })
      return b2b;
    },
  },
  computed: mapState ({
    customCategories: state => state.products.customCategories,
    cartProductsList: state => state.cart.cartProductsList, // not used, in mathod still geting form $store
    necessaryCartItems: state => state.cart.necessaryCartItems,
    business: state => state.auth.userDetails.IsBusiness,
    userDetails: state => state.auth.userDetails,
  }),
  mounted() {
    this.$store.dispatch('recipe/fetch4Recipes');
    if (isUserAuthenticated()) {
      this.isB2B()
      .then((res) => {
        if (!res) {
          this.$store.dispatch('products/fetchCustomCategories', this.business);
        }
      });
    } else {
      this.$store.dispatch('products/fetchCustomCategories', this.business);
    }
    this.$store.dispatch('products/fetchCustomCategoriesAll', this.business);
  },
  watch: {
    'userDetails.IsBusiness': {
      handler: function(newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
          this.$store.dispatch('products/fetchCustomCategories', this.business);
        }
      deep: true
      }
    }
  }
}
</script>

<style lang="less">
@import "../../assets/css/public.less";
@import "../../assets/css/home.less";
</style>



// WEBPACK FOOTER //
// src/view/Home/b2cHome.vue